import {
  Avatar,
  Button,
  Grid,
  makeStyles,
  Typography,
} from "@material-ui/core";
import React from "react";
import CoinChart from "./CoinChart";
import { Link } from "react-router-dom";
import CoinHeader from "../CoinHeader/CoinHeader";
import CustomButton from "../Button/CustomButton";

const useStyles = makeStyles((theme) => ({
  viewMore: {
    textAlign: "center",
    margin: 24,
  },
}));

function CoinRowExpand({ coinData }) {
  const classes = useStyles();
  console.log(coinData);
  return (
    <Grid container>
      <Grid item xs={12}>
        <CoinHeader coinData={coinData} />
      </Grid>
      <Grid item xs={12}>
        <CoinChart
          coinId={coinData.id}
          interval={"1D"}
          postive={parseFloat(coinData.changePercent24Hr) > 0 ? true : false}
        />
      </Grid>
      <Grid item xs={12} className={classes.viewMore}>
        <Link to={`coins/${coinData.id}`} style={{ textDecoration: "none" }}>
          <CustomButton text={"View More"} />
        </Link>
      </Grid>
    </Grid>
  );
}

export default CoinRowExpand;
